import axios from '@/utils/request'

const ApiUrl = '/admin_api/v1/service'

/**
 * @description: 获取订单列表
 * @param {*} params
 * @return {*}
 */
export function getList(params) {
  return axios.get(`${ApiUrl}/assign/list/`, {
    params
  })
}

export function getDeviceData(guideServiceId) {
  return axios.get(`${ApiUrl}/assign/${guideServiceId}/device-data/`)
}

/**
 * @description: 取消派单
 * @param {*} trip_service_id
 * @return {*}
 */

export function cancel(data) {
  return axios.post(`${ApiUrl}/assign/cancel/`, data)
}

/**
 * @description: 发送微信信息
 * @param {*} data
 * @return {*}
 */
export function send(data) {
  return axios.post(`${ApiUrl}/assign/send/`, data)
}

export function sendBatch(data) {
  return axios.post(`${ApiUrl}/assign/send_batch/`, data)
}

/**
 * @description: 确认客户到达
 * @param {*} data
 * @return {*}
 */
export function arriveConfirm(data) {
  return axios.post(`${ApiUrl}/trip/arrive_confirm/`, data)
}
